import { render, staticRenderFns } from "./directives-work-item-type-card.component.vue?vue&type=template&id=3d1990cf&scoped=true&"
import script from "./directives-work-item-type-card.component.vue?vue&type=script&lang=ts&"
export * from "./directives-work-item-type-card.component.vue?vue&type=script&lang=ts&"
import style0 from "./directives-work-item-type-card.component.vue?vue&type=style&index=0&id=3d1990cf&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d1990cf",
  null
  
)

export default component.exports